import { RefObject } from "react";
import styled from "styled-components";
import Modal from "../../../shared/Modal";
import DocumentPreview, {
  useDocumentPreview,
} from "../../../contract/preview/DocumentPreview";

export interface PreviewModalProps {
  isOpen: boolean;
  button?: RefObject<HTMLElement>;
  onClose(): void;
}

const MenuModal = styled(Modal)`
  margin: auto;
  max-width: 30em;
  width: 100%;
`;

export default function PreviewModal({
  isOpen,
  button,
  onClose,
}: PreviewModalProps) {
  const documentPreview = useDocumentPreview();
  return (
    <MenuModal
      isOpen={isOpen}
      button={button}
      onClose={onClose}
      title="Forhåndsvisning"
    >
      <DocumentPreview
        loading={documentPreview.loading}
        result={documentPreview.result!}
      />
    </MenuModal>
  );
}
